import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

// Project
import App from "@/App";
// Store
import { store } from "./store/store";
import { Provider } from "react-redux";

// ========|| Main - React DOM render ||========

const basename = document.querySelector("meta[name='basename']").getAttribute("content") ?? "/";
const container = document.getElementById("app-root");
const root = createRoot(container);

root.render(
    <StrictMode>
        <Provider store={store}>
            <BrowserRouter basename={basename}>
                <App />
            </BrowserRouter>
        </Provider>
    </StrictMode>
);
